import { createFileRoute } from '@tanstack/react-router';
import { requireRole } from '@/lib/routeGuards';
import { ElectionOutcomesAdmin } from '@/components/finance';

// ADR-076 (#627) — the per-subsidiary won/lost admin view. Platform-admin only and subsidiary-WIDE
// (not campaign-scoped), so it guards on the platform-admin role rather than a Finance capability;
// the API is the durable gate (403 for a non-admin).
export const Route = createFileRoute('/admin/election-outcomes')({
  beforeLoad: ({ context }) => {
    requireRole(context, ['admin'], '/admin/election-outcomes');
  },
  component: ElectionOutcomesAdmin,
});
